/**
 * Transforms Auxo Asset CDN URLs into optimized variants with Cloudflare on-the-fly resizing.
 */
export function optimizeImage(url, width = 800, quality = 80) {
  if (!url || typeof url !== 'string') return url;

  // If plain filename or asset path
  if (!url.startsWith('http') && !url.startsWith('/')) {
    url = `https://assets.auxodev.dk/assets/ece5dc05-bafb-437f-b627-764ef307b8ad/${url}`;
  }

  // Only rewrite URLs whose host is assets.auxodev.dk and not already transformed
  if (url.startsWith('https://assets.auxodev.dk/') && !url.includes('/cdn-cgi/image/')) {
    const path = url.replace('https://assets.auxodev.dk/', '');
    return `https://assets.auxodev.dk/cdn-cgi/image/width=${width},quality=${quality},format=auto/${path}`;
  }

  return url;
}
